import React from "react";
import { Box, Paper, Stack, Text, ThemeIcon } from "@mantine/core";
import { IconLock } from "@tabler/icons-react";
import { useDevToolsBlock } from "../../../hooks/useDevToolsBlock";

const DevToolsBlocker: React.FC = () => {
  const { enabled, isDevToolsOpen } = useDevToolsBlock();

  if (!enabled || !isDevToolsOpen) {
    return null;
  }

  return (
    <Box
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 99999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        background: "rgba(15, 23, 42, 0.92)",
        backdropFilter: "blur(4px)",
      }}
    >
      <Paper
        shadow='lg'
        radius='md'
        p={40}
        style={{
          maxWidth: 460,
          width: "100%",
          textAlign: "center",
        }}
      >
        <Stack align='center' gap='lg'>
          <ThemeIcon size={72} radius='xl' color='red' variant='light'>
            <IconLock size={34} />
          </ThemeIcon>
          <Box>
            <Text size='xl' fw={600} mb={8}>
              Developer Tools Detected
            </Text>
            <Text size='sm' c='dimmed'>
              Browser developer tools must be closed to continue using this
              application.
            </Text>
          </Box>
        </Stack>
      </Paper>
    </Box>
  );
};

export default DevToolsBlocker;
